"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _ChevronRight2 = _interopRequireDefault(require("@mui/icons-material/ChevronRight"));
var _Divider2 = _interopRequireDefault(require("@mui/material/Divider"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _TextField2 = _interopRequireDefault(require("@mui/material/TextField"));
var _InputAdornment2 = _interopRequireDefault(require("@mui/material/InputAdornment"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Button3 = _interopRequireDefault(require("@mui/material/Button"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _findIllus = _interopRequireDefault(require("../../../assets/images/find-illus.svg"));
var _hooks = require("../../../hooks");
var _services = require("../../../services");
var _icons = require("../../icons");
var _user = require("../../user");
var _medals = require("../medals");
var _item = _interopRequireDefault(require("./item"));
var _rankCard = _interopRequireDefault(require("./rank-card"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function IndividualLeaderboardHome({
  Button: _Button,
  isFree,
  event,
  freeOfferEmployeesLeaderboardsMaxRowsCount,
  currentUser,
  displayLeaderboard,
  setSearch
}) {
  const [initialized, setInitialized] = (0, _react.useState)(false);
  const [leaderboard, setLeaderboard] = (0, _react.useState)();
  const [numberOfParticipants, setNumberOfParticipants] = (0, _react.useState)();
  const [userItem, setUserItem] = (0, _react.useState)();
  const [tmpSearch, setTmpSearch] = (0, _react.useState)('');
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    cancellablePromise,
    cancelPromises
  } = (0, _hooks.useCancellablePromise)();
  (0, _react.useEffect)(() => {
    if (initialized) getLeaderboard();
    setInitialized(true);
    return () => {
      cancelPromises();
      setLeaderboard(undefined);
      setNumberOfParticipants(undefined);
      setUserItem(undefined);
    };
  }, [initialized]);
  async function getLeaderboard() {
    try {
      const [{
        count,
        items
      }, {
        items: [userItem]
      }] = await cancellablePromise(Promise.all([_services.EventService.getIndividualRanking(event.id, {
        page: 1,
        pageSize: isFree ? freeOfferEmployeesLeaderboardsMaxRowsCount : 10
      }), currentUser ? _services.EventService.getIndividualRanking(event.id, {
        page: 1,
        pageSize: 1,
        getConnectedUserRank: true
      }) : {
        items: [null]
      }]));
      setLeaderboard(items);
      setNumberOfParticipants(count);
      setUserItem(userItem || null);
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        console.error(err);
      }
    }
  }
  const Button = _Button || _Button3.default;
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 3,
    paddingY: 3
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: "#fff",
    borderRadius: 4,
    padding: 3
  }, /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    fullWidth: true,
    margin: "none",
    onChange: ({
      currentTarget: {
        value
      }
    }) => setTmpSearch(value),
    onKeyDown: ({
      key
    }) => {
      if (key === 'Enter') {
        setSearch(tmpSearch);
        if (tmpSearch) displayLeaderboard(true);
      }
    },
    placeholder: t('commons.challenges.leaderboard.search_cyclist') || '',
    size: "small",
    slotProps: {
      input: {
        endAdornment: tmpSearch && /*#__PURE__*/_react.default.createElement(_InputAdornment2.default, {
          position: "end"
        }, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
          title: "Rechercher"
        }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
          disabled: !tmpSearch,
          onClick: () => {
            setSearch(tmpSearch);
            if (tmpSearch) displayLeaderboard(true);
          },
          size: "small"
        }, /*#__PURE__*/_react.default.createElement(_icons.SearchIcon, {
          fontSize: "small"
        })))))
      }
    },
    sx: {
      '.MuiInputBase-root': {
        bgcolor: '#fff'
      }
    },
    type: "text",
    value: tmpSearch,
    variant: "outlined"
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    bgcolor: "#fff",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    gap: 3,
    paddingX: 3,
    paddingY: 8
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    fontWeight: 700,
    variant: "h6"
  }, t('commons.challenges.leaderboard.title_individual_top')), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    color: "textSecondary",
    variant: "body2"
  }, t('commons.challenges.leaderboard.description_individual'))), /*#__PURE__*/_react.default.createElement(_rankCard.default, {
    challengeTemplate: event.challengeTemplate,
    numberOfParticipants: numberOfParticipants,
    progress: userItem
  }), !leaderboard || leaderboard.length > 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 3,
    sx: {
      containerType: 'inline-size'
    },
    width: "100%"
  }, (!leaderboard || leaderboard.length >= 3) && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "stretch",
    display: {
      '@': 'none',
      '@600': 'flex'
    },
    gap: 3,
    width: "100%"
  }, [0, 1, 2].map(index => (!leaderboard || leaderboard[index]) && /*#__PURE__*/_react.default.createElement(PodiumStep, {
    challengeType: event.challengeTemplate?.type || 'bttf',
    index: index,
    item: leaderboard?.[index],
    key: index
  }))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    border: "1px solid #dde0e7",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    width: "100%"
  }, leaderboard ? leaderboard.map((item, index) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: item.user.id
  }, index > 0 && /*#__PURE__*/_react.default.createElement(_Divider2.default, {
    sx: {
      borderColor: '#dde0e7'
    }
  }), /*#__PURE__*/_react.default.createElement(_item.default, {
    challengeType: event.challengeTemplate?.type,
    item: item,
    prevItemRank: index > 0 ? leaderboard[index - 1].rank : null
  }))) : new Array(10).fill(null).map((_, index) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: index
  }, index > 0 && /*#__PURE__*/_react.default.createElement(_Divider2.default, {
    sx: {
      borderColor: '#dde0e7'
    }
  }), /*#__PURE__*/_react.default.createElement(_item.default, {
    challengeType: event.challengeTemplate?.type,
    prevItemRank: null
  }))))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(Button, {
    color: "primary",
    endIcon: /*#__PURE__*/_react.default.createElement(_ChevronRight2.default, null),
    onClick: () => displayLeaderboard(true),
    size: "medium",
    variant: "contained"
  }, t('commons.challenges.leaderboard.actions.see_entire_leaderboard')))) : /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 3,
    paddingY: 5
  }, /*#__PURE__*/_react.default.createElement("img", {
    height: 64,
    src: _findIllus.default
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    fontWeight: 700
  }, t('commons.challenges.leaderboard.empty_state_title_individual')), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    variant: "body2"
  }, t('commons.challenges.leaderboard.empty_state_description'))))));
}
function PodiumStep({
  challengeType,
  index,
  item
}) {
  const {
    getProgressValueWithUnit
  } = (0, _hooks.useChallenge)();
  const {
    color,
    icon
  } = _medals.medals[index];
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    bgcolor: color,
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    gap: 5,
    padding: 3,
    width: "calc((100% - 48px) / 3)"
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    position: "relative"
  }, /*#__PURE__*/_react.default.createElement(_user.UserAvatar, {
    size: 72,
    user: item?.user
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: icon,
    style: {
      position: 'absolute',
      bottom: -20,
      left: 'calc(50% - 16px)'
    },
    width: 32
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    align: "center",
    fontWeight: 700,
    title: item?.user.username
  }, item?.user.username || /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  })), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    variant: "body2"
  }, item ? getProgressValueWithUnit(challengeType, item.progressValue) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 50
  }))));
}
var _default = exports.default = IndividualLeaderboardHome;